'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Utils


// Constants


var _formSubReducerWrapper = require('../../../components/form/formSubReducerWrapper');

var _formSubReducerWrapper2 = _interopRequireDefault(_formSubReducerWrapper);

var _registerFormConstants = require('./registerFormConstants');

var _authConstants = require('../../authConstants');

var AUTH_ACTION_TYPES = _interopRequireWildcard(_authConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var registerSubFormReducer = function registerSubFormReducer(state, action) {
    switch (action.type) {
        case AUTH_ACTION_TYPES.REGISTER_INVITE_FETCHED:
            return _extends({}, state, { email: { value: action.email } });
        default:
            return state;
    }
};

exports.default = (0, _formSubReducerWrapper2.default)(registerSubFormReducer, _registerFormConstants.REGISTER_FORM_NAME);


//////////////////
// WEBPACK FOOTER
// ./src/client/auth/modals/register/registerFormReducer.js
// module id = 1686
// module chunks = 0